import React, { useEffect, useMemo, useState, useRef } from "react";

import { Lottie } from "lottie-react";

import allProductsAnimation from "../assets/shopping/all-products.json";
import allShopsAnimation from "../assets/shopping/all-shops.json";
import shopOrdersAnimation from "../assets/shopping/shop-orders.json";
import myOrdersAnimation from "../assets/shopping/my-orders.json";

import { PRODUCT_CATEGORIES } from "../constants/categories.js";

import {
  getDocs,
  getDoc,
  collection,
  query,
  where,
  onSnapshot,
  doc,
  updateDoc,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

import {
  db,
  getPostsFeed,
  getVideosFeed,
  getWallet,
  getUserSettings,
} from "../firebase";

import SearchBar from "../components/SearchBar";
import PostComposer from "../components/PostComposer";

import {
  PostCard,
  ProductCard,
  ShopCard,
  NewsCard,
  InfoCard,
  shuffleArray,
} from "../components/Cards";

import {
  FaWhatsapp,
  FaShoppingBag,
  FaStore,
  FaShoppingCart,
  FaReceipt,
  FaRobot,
  FaGamepad,
  FaNewspaper,
  FaMapMarkerAlt,
  FaUserCircle,
  FaWallet,
  FaClipboardList,
  FaTaxi,
  FaUserPlus,
  FaRoute,
  FaTimes,
  FaHeart,
  FaMotorcycle,
  FaBullhorn,
  FaTruck,
  FaBriefcase,
  FaGift,
  FaCashRegister,
} from "react-icons/fa";

import "../styles/Home.css";

export default function Home() {

  const navigate = useNavigate();

  const postsScrollRef = useRef(null);
  const productsScrollRef = useRef(null);
  const categoryScrollRef = useRef(null);

const { user, userProfile } = useAuth();

const EPOS_UID = "jKahzGJWb2hRmWWrppjWCiazpFd2";

const { cart } = useCart();

const cartCount = cart.reduce(
  (sum, item) => sum + item.qty,
  0
);

const [notificationCount, setNotificationCount] = useState(0);
const [orderNotificationCount, setOrderNotificationCount] = useState(0);

const [rideRequestCount, setRideRequestCount] = useState(0);
const [myRideCount, setMyRideCount] = useState(0);

const [activities, setActivities] = useState([]);
const [activeActivitySlide, setActiveActivitySlide] = useState(0);

const [walletBalance, setWalletBalance] = useState(0);

const [isDeliveryPerson, setIsDeliveryPerson] = useState(false);

const [deliveryRequests, setDeliveryRequests] = useState([]);

const [isProfileIncomplete, setIsProfileIncomplete] = useState(false);
const [isDeliveryAreaMissing, setIsDeliveryAreaMissing] = useState(false);
const [profileChecked, setProfileChecked] = useState(false);

  const [search,setSearch]=useState("");

  const [posts,setPosts]=useState([]);
  const [products,setProducts]=useState([]);
  const [shops,setShops]=useState([]);
  const [news,setNews]=useState([]);
  const [info,setInfo]=useState([]);

  const [loading,setLoading]=useState(true);


const [deliveryPersonData, setDeliveryPersonData] =
  useState(null);

const [deliveryNow, setDeliveryNow] =
  useState(Date.now());
  

 // =====================================================
// HOME ACTIVITIES - ONLY SHOW FOR 24 HOURS
// =====================================================

useEffect(() => {

  if (!user) {
    setActivities([]);
    setNotificationCount(0);
    setOrderNotificationCount(0);
    setRideRequestCount(0);
    setMyRideCount(0);
    return;
  }

  const activityQuery = query(
    collection(db, "activity"),
    where("uid", "==", user.uid),
    where("read", "==", false)
  );

  const unsubscribe = onSnapshot(
    activityQuery,
    (snapshot) => {

      const now = Date.now();

      // 24 hours in milliseconds
      const twentyFourHours = 24 * 60 * 60 * 1000;

      const data = snapshot.docs
        .map((activityDoc) => ({
          id: activityDoc.id,
          ...activityDoc.data(),
        }))
        .filter((item) => {

          // If there is no createdAt,
          // don't show the activity.
          if (!item.createdAt) {
            return false;
          }

          const createdTime =
            item.createdAt?.toMillis
              ? item.createdAt.toMillis()
              : 0;

          // Show only activities created
          // within the last 24 hours.
          return (
            createdTime > 0 &&
            now - createdTime < twentyFourHours
          );

        })
        .sort((a, b) => {

          const aTime = a.createdAt?.toMillis
            ? a.createdAt.toMillis()
            : 0;

          const bTime = b.createdAt?.toMillis
            ? b.createdAt.toMillis()
            : 0;

          return bTime - aTime;

        });

      // =========================
      // FOR YOU
      // =========================

      setActivities(data);

      // =========================
      // TOTAL NOTIFICATIONS
      // =========================

      setNotificationCount(data.length);

      // =========================
      // ORDERS
      // =========================

      setOrderNotificationCount(
        data.filter(
          (item) =>
            item.type === "order_placed" ||
            item.type === "shop_order"
        ).length
      );

      // =========================
      // RIDE REQUESTS
      // =========================

      setRideRequestCount(
        data.filter(
          (item) =>
            item.type === "ride_request"
        ).length
      );

      // =========================
      // MY RIDES
      // =========================

      setMyRideCount(
        data.filter((item) =>
          [
            "ride_booked",
            "ride_accepted",
            "ride_completed",
          ].includes(item.type)
        ).length
      );

    },

    (error) => {

      console.error(
        "Home activity error:",
        error
      );

    }
  );

  // =====================================================
  // IMPORTANT:
  // Firestore won't update just because 24 hours passed.
  // Refresh the activity list every minute so an old
  // notification disappears automatically.
  // =====================================================

  const refreshTimer = setInterval(() => {

    setActivities((prev) => {

      const now = Date.now();
      const twentyFourHours =
        24 * 60 * 60 * 1000;

      return prev.filter((item) => {

        if (!item.createdAt) {
          return false;
        }

        const createdTime =
          item.createdAt?.toMillis
            ? item.createdAt.toMillis()
            : 0;

        return (
          createdTime > 0 &&
          now - createdTime < twentyFourHours
        );

      });

    });

  }, 60 * 1000); // every 1 minute

  return () => {

    unsubscribe();

    clearInterval(refreshTimer);

  };

}, [user]);

useEffect(() => {

  if (!user) {
    setWalletBalance(0);
    return;
  }

  const loadWalletBalance = async () => {

    try {

      const walletData = await getWallet(user.uid);

      setWalletBalance(
        Number(walletData?.balance || 0)
      );

    } catch (error) {

      console.error(
        "Home wallet error:",
        error
      );

      setWalletBalance(0);
    }

  };

  loadWalletBalance();

}, [user]);

// =====================================================
// CHECK DELIVERY PERSON
// =====================================================

useEffect(() => {

  if (!user?.uid) {
    setIsDeliveryPerson(false);
    return;
  }

  const checkDeliveryPerson = async () => {

    try {

      const deliveryRef = doc(
        db,
        "deliveryPersons",
        user.uid
      );

      const deliverySnap = await getDoc(deliveryRef);

      if (deliverySnap.exists()) {

        const data = deliverySnap.data();

        setIsDeliveryPerson(
          data.verified === true
        );

      } else {

        setIsDeliveryPerson(false);

      }

    } catch (error) {

      console.error(
        "Delivery person check error:",
        error
      );

      setIsDeliveryPerson(false);
    }

  };

  checkDeliveryPerson();

}, [user]);

// =====================================================
// DELIVERY PERSON - LIVE AVAILABILITY
//
// Uses the SAME Firestore document and
// availabilityExpiresAt as DeliveryDashboard.
//
// This keeps the timer synchronized across:
//   • Home
//   • Delivery Dashboard
//
// No separate timer is stored in Home.
// =====================================================

useEffect(() => {

  if (
    !user?.uid ||
    !isDeliveryPerson
  ) {

    setDeliveryPersonData(null);

    return;

  }


  const deliveryRef =
    doc(
      db,
      "deliveryPersons",
      user.uid
    );


  /*
   * LIVE LISTENER
   *
   * Whenever delivery person checks in,
   * checks out, accepts an order, or the
   * availability expiry changes, Home
   * immediately receives the new data.
   */

  const unsubscribe =
    onSnapshot(

      deliveryRef,

      (snapshot) => {

        if (!snapshot.exists()) {

          setDeliveryPersonData(null);

          return;

        }


        const data =
          snapshot.data();


        setDeliveryPersonData({

          id:
            snapshot.id,

          ...data,

        });

      },

      (error) => {

        console.error(
          "Home delivery availability error:",
          error
        );

        setDeliveryPersonData(null);

      }

    );


  return () =>
    unsubscribe();

}, [
  user,
  isDeliveryPerson,
]);

// =====================================================
// HOME DELIVERY TIMER CLOCK
// =====================================================

useEffect(() => {

  /*
   * Only run the clock when this user
   * is a delivery person.
   */

  if (!isDeliveryPerson) {
    return;
  }


  const timer =
    setInterval(
      () => {

        setDeliveryNow(
          Date.now()
        );

      },
      1000
    );


  return () =>
    clearInterval(timer);

}, [
  isDeliveryPerson,
]);


// =====================================================
// CHECK USER PROFILE + DELIVERY AREA
// =====================================================

useEffect(() => {

  if (!user?.uid) {

    setIsProfileIncomplete(false);
    setIsDeliveryAreaMissing(false);
    setProfileChecked(false);

    return;
  }

  const checkProfileCompletion = async () => {

    try {

      const profile =
        await getUserSettings(user.uid);

      // =========================
      // PROFILE FIELDS
      // =========================

      const name = String(
        profile?.name ||
        user?.displayName ||
        ""
      ).trim();

      const mobile = String(
        profile?.mobile || ""
      )
        .replace("+91", "")
        .trim();

      const address = String(
        profile?.address || ""
      ).trim();

      // =========================
      // DELIVERY AREA
      // =========================

      const area = String(
        profile?.area || ""
      ).trim();

      // =========================
      // PROFILE INCOMPLETE
      //
      // Area is NOT included here.
      // It has its own notification.
      // =========================

      const incomplete =
        !name ||
        !mobile ||
        !address;

      setIsProfileIncomplete(
        incomplete
      );

      // =========================
      // DELIVERY AREA MISSING
      // =========================

      setIsDeliveryAreaMissing(
        !area
      );

    } catch (error) {

      console.error(
        "Profile completion check error:",
        error
      );

      // If profile cannot be loaded,
      // keep both notifications visible.
      setIsProfileIncomplete(true);
      setIsDeliveryAreaMissing(true);

    } finally {

      setProfileChecked(true);

    }

  };

  checkProfileCompletion();

}, [user]);

// =====================================================
// HOME DELIVERY AVAILABILITY TIMER
// =====================================================

const getHomeDeliveryExpiryMillis =
  () => {

    const expiry =
      deliveryPersonData
        ?.availabilityExpiresAt;


    if (!expiry) {
      return null;
    }


    /*
     * Firestore Timestamp
     */

    if (
      typeof expiry.toMillis ===
      "function"
    ) {

      return expiry.toMillis();

    }


    /*
     * JavaScript Date / string fallback
     */

    const millis =
      new Date(
        expiry
      ).getTime();


    return Number.isFinite(
      millis
    )
      ? millis
      : null;

  };


const homeDeliveryExpiryMillis =
  getHomeDeliveryExpiryMillis();


const homeDeliveryRemainingMillis =
  homeDeliveryExpiryMillis
    ? Math.max(
        0,
        homeDeliveryExpiryMillis -
          deliveryNow
      )
    : 0;


const homeDeliveryRemainingMinutes =
  Math.floor(
    homeDeliveryRemainingMillis /
      60000
  );


const homeDeliveryRemainingSeconds =
  Math.floor(
    (
      homeDeliveryRemainingMillis %
      60000
    ) /
      1000
  );


const homeDeliveryRemainingText =
  `${homeDeliveryRemainingMinutes
    .toString()
    .padStart(2, "0")}:${homeDeliveryRemainingSeconds
    .toString()
    .padStart(2, "0")}`;


/*
 * IMPORTANT
 *
 * available must be true AND
 * expiry must still be in the future.
 */

const homeDeliveryIsAvailable =
  deliveryPersonData?.available ===
    true &&
  homeDeliveryExpiryMillis !==
    null &&
  homeDeliveryExpiryMillis >
    deliveryNow;


    // =====================================================
// HOME - EXPIRE DELIVERY AVAILABILITY
// =====================================================

useEffect(() => {

  if (
    !user?.uid ||
    !isDeliveryPerson
  ) {
    return;
  }


  if (
    !deliveryPersonData?.available
  ) {
    return;
  }


  if (
    !homeDeliveryExpiryMillis
  ) {
    return;
  }


  /*
   * Do NOT expire while an active
   * delivery is being handled.
   */

  if (
    deliveryPersonData.currentOrderId
  ) {
    return;
  }


  if (
    deliveryNow >=
    homeDeliveryExpiryMillis
  ) {

    const deliveryRef =
      doc(
        db,
        "deliveryPersons",
        user.uid
      );


    updateDoc(
      deliveryRef,
      {

        available:
          false,

        availabilityExpiresAt:
          null,

        updatedAt:
          serverTimestamp(),

      }
    ).catch(
      (error) => {

        console.error(
          "Home availability expiry error:",
          error
        );

      }
    );

  }

}, [
  user,
  isDeliveryPerson,
  deliveryPersonData?.available,
  deliveryPersonData?.currentOrderId,
  homeDeliveryExpiryMillis,
  deliveryNow,
]);


// =====================================================
// DELIVERY PERSON - LIVE NEW DELIVERY NOTIFICATION
// =====================================================

useEffect(() => {

  if (!user || !isDeliveryPerson) {
    setDeliveryRequests([]);
    return;
  }

  const deliveryQuery = query(
    collection(db, "deliveryRequests"),
    where("deliveryPersonUid", "==", user.uid)
  );

  const unsubscribe = onSnapshot(
    deliveryQuery,
    (snapshot) => {

      const requests = snapshot.docs
        .map((requestDoc) => ({
          id: requestDoc.id,
          ...requestDoc.data(),
        }))
        .filter(
          (request) =>
            request.status === "ASSIGNED"
        )
        .sort((a, b) => {

          const aTime =
            a.createdAt?.toMillis
              ? a.createdAt.toMillis()
              : 0;

          const bTime =
            b.createdAt?.toMillis
              ? b.createdAt.toMillis()
              : 0;

          return bTime - aTime;
        });

      setDeliveryRequests(requests);
    },

    (error) => {

      console.error(
        "Home delivery notification error:",
        error
      );

      setDeliveryRequests([]);
    }
  );

  return () => unsubscribe();

}, [user, isDeliveryPerson]);


  useEffect(()=>{
      loadData();
  },[]);

  async function loadData(){

      setLoading(true);

      try{

          const [
    images,
    videos,
    productsSnap,
    shopProductsSnap,
    shopsSnap,
    newsSnap,
    infoSnap,
] = await Promise.all([
    getPostsFeed(),
    getVideosFeed(),

    // Eyal Mart products
    getDocs(collection(db, "products")),

    // Shop products
    getDocs(collection(db, "shopproducts")),

    getDocs(collection(db, "shops")),
    getDocs(collection(db, "localNews")),
    getDocs(collection(db, "infoexchange")),
]);

          setPosts(
              shuffleArray([
                  ...images,
                  ...videos
              ])
          );

          const normalProducts = productsSnap.docs.map((doc) => ({
  product_id: doc.id,
  source: "product",
  ...doc.data(),
}));

const shopProducts = shopProductsSnap.docs
  .map((doc) => {
    const data = doc.data();

    return {
      product_id: doc.id,
      source: "shop",

      // Normalize shop product fields
      name: data.name || "Product",
      image:
        data.image ||
        data.imageUrl ||
        data.images?.[0] ||
        "",

      price: Number(data.price || 0),
      mrp: Number(data.mrp || data.price || 0),

      brand: data.brand || "",
      category: data.category || "",
      description: data.description || "",

      shopId: data.shopId || "",
      shopName: data.shopName || "",
      ownerUid: data.ownerUid || "",

      stock: Number(data.stock ?? 0),
      active: data.active !== false,

      ...data,
    };
  })
  .filter((product) => product.active !== false);

setProducts(
  shuffleArray([
    ...normalProducts,
    ...shopProducts,
  ])
);

          setShops(
              shuffleArray(
                  shopsSnap.docs.map(doc=>({
                      id:doc.id,
                      ...doc.data()
                  }))
              )
          );

          setNews(
              shuffleArray(
                  newsSnap.docs.map(doc=>({
                      id:doc.id,
                      ...doc.data()
                  }))
              )
          );

          setInfo(
              shuffleArray(
                  infoSnap.docs.map(doc=>({
                      id:doc.id,
                      ...doc.data()
                  }))
              )
          );

      }finally{

          setLoading(false);

      }

  }

 // =====================================================
// PRODUCT CATEGORY ICON
// USE SHARED CATEGORY ICON
// =====================================================

const getCategoryIcon = (category) => {
  return category.icon || "🛍️";
};


// =====================================================
// EYAL APP - FIXED PRODUCT CATEGORIES
// SAME CATEGORIES AS ADDPRODUCT.JS
// =====================================================

const productCategories = PRODUCT_CATEGORIES;

  

  // =========================
// AUTO SCROLL POSTS
// RIGHT → LEFT
// =========================

useEffect(() => {

  if (!posts.length) return;

  const slider = postsScrollRef.current;

  if (!slider) return;

  let animationFrame;
  let paused = false;

  const scroll = () => {

    if (!paused) {

      slider.scrollLeft += 0.5;

      // When reaching the end,
      // smoothly start again from beginning
      if (
        slider.scrollLeft >=
        slider.scrollWidth - slider.clientWidth
      ) {
        slider.scrollLeft = 0;
      }

    }

    animationFrame =
      requestAnimationFrame(scroll);
  };

  animationFrame =
    requestAnimationFrame(scroll);

  // Pause when user touches / hovers
  const pause = () => {
    paused = true;
  };

  const resume = () => {
    paused = false;
  };

  slider.addEventListener("mouseenter", pause);
  slider.addEventListener("mouseleave", resume);
  slider.addEventListener("touchstart", pause);
  slider.addEventListener("touchend", resume);

  return () => {

    cancelAnimationFrame(animationFrame);

    slider.removeEventListener(
      "mouseenter",
      pause
    );

    slider.removeEventListener(
      "mouseleave",
      resume
    );

    slider.removeEventListener(
      "touchstart",
      pause
    );

    slider.removeEventListener(
      "touchend",
      resume
    );

  };

}, [posts]);

// =========================
// AUTO SCROLL CATEGORIES
// RIGHT → LEFT
// AUTO START + INFINITE
// =========================

useEffect(() => {

  if (!productCategories.length) return;

  const slider = categoryScrollRef.current;

  if (!slider) return;

  let animationFrame;

  // Start automatically from the beginning
  slider.scrollLeft = 0;

  const scroll = () => {

    slider.scrollLeft += 0.5;

    // Infinite loop
    // Reset after half of the duplicated content
    if (
      slider.scrollLeft >=
      slider.scrollWidth / 2
    ) {
      slider.scrollLeft = 0;
    }

    animationFrame =
      requestAnimationFrame(scroll);
  };

  animationFrame =
    requestAnimationFrame(scroll);

  return () => {
    cancelAnimationFrame(animationFrame);
  };

}, [productCategories]);

// =========================
// AUTO SCROLL PRODUCTS
// LEFT → RIGHT
// =========================

useEffect(() => {

  if (!products.length) return;

  const slider = productsScrollRef.current;

  if (!slider) return;

  let animationFrame;
  let paused = false;

  // Start from the RIGHT side
  slider.scrollLeft =
    slider.scrollWidth - slider.clientWidth;

  const scroll = () => {

    if (!paused) {

      // Move content LEFT → RIGHT visually
      slider.scrollLeft -= 0.6;

      // Reached the left edge
      if (slider.scrollLeft <= 0) {

        slider.scrollLeft =
          slider.scrollWidth - slider.clientWidth;

      }

    }

    animationFrame =
      requestAnimationFrame(scroll);
  };

  animationFrame =
    requestAnimationFrame(scroll);


  // Pause on hover / touch
  const pause = () => {
    paused = true;
  };

  const resume = () => {
    paused = false;
  };


  slider.addEventListener(
    "mouseenter",
    pause
  );

  slider.addEventListener(
    "mouseleave",
    resume
  );

  slider.addEventListener(
    "touchstart",
    pause,
    { passive: true }
  );

  slider.addEventListener(
    "touchend",
    resume
  );


  return () => {

    cancelAnimationFrame(animationFrame);

    slider.removeEventListener(
      "mouseenter",
      pause
    );

    slider.removeEventListener(
      "mouseleave",
      resume
    );

    slider.removeEventListener(
      "touchstart",
      pause
    );

    slider.removeEventListener(
      "touchend",
      resume
    );

  };

}, [products]);

// =========================
// AUTO SCROLL CATEGORIES
// LEFT → RIGHT
// =========================

useEffect(() => {

  if (!productCategories.length) return;

  const slider = categoryScrollRef.current;

  if (!slider) return;

  let animationFrame;
  let paused = false;

  const scroll = () => {

    if (!paused) {

      slider.scrollLeft -= 0.4;

      if (slider.scrollLeft <= 0) {
        slider.scrollLeft =
          slider.scrollWidth - slider.clientWidth;
      }

    }

    animationFrame =
      requestAnimationFrame(scroll);
  };

  slider.scrollLeft =
    slider.scrollWidth - slider.clientWidth;

  animationFrame =
    requestAnimationFrame(scroll);

  const pause = () => {
    paused = true;
  };

  const resume = () => {
    paused = false;
  };

  slider.addEventListener(
    "mouseenter",
    pause
  );

  slider.addEventListener(
    "mouseleave",
    resume
  );

  slider.addEventListener(
    "touchstart",
    pause,
    { passive: true }
  );

  slider.addEventListener(
    "touchend",
    resume
  );

  return () => {

    cancelAnimationFrame(animationFrame);

    slider.removeEventListener(
      "mouseenter",
      pause
    );

    slider.removeEventListener(
      "mouseleave",
      resume
    );

    slider.removeEventListener(
      "touchstart",
      pause
    );

    slider.removeEventListener(
      "touchend",
      resume
    );

  };

}, [productCategories]);


  const feed=useMemo(()=>{

      const merged=[];

      posts.forEach(item=>merged.push({type:"post",data:item}));
      // products.forEach(item=>merged.push({type:"product",data:item}));
      shops.forEach(item=>merged.push({type:"shop",data:item}));
      news.forEach(item=>merged.push({type:"news",data:item}));
      info.forEach(item=>merged.push({type:"info",data:item}));

      const keyword=search.toLowerCase();

      const filtered=merged.filter(item=>{

          if(!keyword) return true;

          return JSON.stringify(item.data)
              .toLowerCase()
              .includes(keyword);

      });

      return shuffleArray(filtered);

  },[
      posts,
      products,
      shops,
      news,
      info,
      search
  ]);

  // =========================
  // MY SHOP
  // =========================

  const handleMyShop = async () => {

    if (!user) {
      navigate("/user/shop");
      return;
    }

    try {

      const q = query(
        collection(db, "shops"),
        where("uid", "==", user.uid)
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {

        const shop = snapshot.docs[0];

        navigate(`/shop/${shop.id}`);

      } else {

        // User has no shop
        navigate("/user/shop");

      }

    } catch (error) {

      console.error(
        "My Shop error:",
        error
      );

    }

  };

  // =====================================================
// FOR YOU ROLE / ACCOUNT STATUS
// =====================================================

const myShop = user
  ? shops.find((shop) => shop.uid === user.uid)
  : null;

console.log("👤 USER PROFILE:", userProfile);

console.log("🚚 DELIVERY STATUS:", {
  deliveryPerson: userProfile?.deliveryPerson,
  isDeliveryPerson: userProfile?.isDeliveryPerson,
  deliveryApproved: userProfile?.deliveryApproved,
});


  if(loading){

      return(
          <div className="home-loading">
              Loading...
          </div>
      );

  }

  


const getActivityIcon = (type) => {
  switch (type) {

    case "shop_order":
    case "order_placed":
      return <FaShoppingCart />;

    case "ride_request":
    case "ride_accepted":
    case "ride_completed":
    case "ride_booked":
      return <FaTaxi />;

    case "delivery_request":
    case "delivery_completed":
      return <FaMotorcycle />;

    case "wallet_balance":
case "wallet_credit":
case "wallet_debit":
  return <FaWallet />;

    case "post_like":
    case "post_comment":
      return <FaHeart />;

    case "shop_approved":
      return <FaStore />;

    case "local_update":
      return <FaNewspaper />;

    case "job":
      return <FaBriefcase />;

    default:
      return <FaBullhorn />;
  }
};

const getActivityBorder = (priority, type) => {

  if (type === "wallet_balance") {
    return "#16a34a";
  }

  switch (priority) {

    case "high":
      return "#ef4444";

    case "medium":
      return "#f59e0b";

    default:
      return "#2563eb";
  }
};

const dismissActivity = async (e, activityId) => {
  e.stopPropagation();

  try {
    await updateDoc(
      doc(db, "activity", activityId),
      {
        read: true,
      }
    );

    setActivities((prev) =>
      prev.filter((item) => item.id !== activityId)
    );

  } catch (error) {
    console.error(
      "Error dismissing activity:",
      error
    );
  }
};

const handleActivityScroll = (e) => {
  const slider = e.currentTarget;

  const slideWidth = slider.clientWidth;

  if (!slideWidth) return;

  const index = Math.round(
    slider.scrollLeft / slideWidth
  );

  setActiveActivitySlide(index);
};


// Wallet Balance hidden from For You for now
// We can display it later.



const homeActivities = activities;

const ShoppingLottieIcon = ({ animation }) => (
  <div className="shopping-lottie-icon">
    <Lottie
      src={animation}
      autoplay
      loop
      style={{
        width: "64px",
        height: "64px",
      }}
    />
  </div>
);

const HomeSection = ({
  title,
  children,
  sectionClassName = "",
}) => (
  <div
    className={`home-menu-section ${sectionClassName}`}
  >
    <h3 className="home-section-title">{title}</h3>

    <div className="home-menu-grid">
      {children}
    </div>
  </div>
);

const HomeMenuItem = ({
  icon,
  label,
  onClick,
  badge,
  dot = false,
}) => (
  <div
    className="home-menu-item"
    onClick={onClick}
  >
    <div className="home-menu-icon-wrapper">

      <div className="home-menu-icon">
  {icon}
</div>

      {dot && (
        <span className="home-menu-notification-dot" />
      )}

      {!dot && badge > 0 && (
        <span className="home-menu-badge">
          {badge > 99 ? "99+" : badge}
        </span>
      )}

    </div>

    <span>{label}</span>
  </div>
);

  return(

     <div className="home-page">

{/* =====================================================
    FOR YOU
===================================================== */}

<div className="home-for-you">

  {/* HEADER */}
  <div className="home-for-you-header">
    <h3>✨ For You</h3>
  </div>


 {/* =================================================
    PERSONAL SHORTCUTS
================================================= */}

<div className="home-menu-grid">

   {/* =================================================
      COMPLETE PROFILE
      SHOW ONLY WHEN PROFILE IS INCOMPLETE
  ================================================= */}

  {profileChecked && isProfileIncomplete && (
  <HomeMenuItem
    icon={<FaUserCircle />}
    label="Update Profile"
    dot={true}
    onClick={() =>
      navigate("/user/settings")
    }
  />
)}

{/* =================================================
    UPDATE DELIVERY AREA
    SHOW ONLY WHEN AREA IS NOT SELECTED
================================================= */}

{profileChecked && isDeliveryAreaMissing && (
  <HomeMenuItem
    icon={<FaMapMarkerAlt />}
    label="Update Delivery Area"
    dot={true}
    onClick={() =>
      navigate("/user/settings")
    }
  />
)}


  {/* WALLET */}
  <HomeMenuItem
    icon={<FaWallet />}
    label={`Wallet ₹${walletBalance}`}
    onClick={() => navigate("/wallet")}
  />

  <HomeMenuItem
  icon={<FaReceipt />}
  label="My Orders"
  badge={orderNotificationCount}
  onClick={() => navigate("/orders")}
/>

  {/* =================================================
      ePOS
      SHOW ONLY TO AUTHORIZED ePOS USER
  ================================================= */}

  {user?.uid === EPOS_UID && (
    <HomeMenuItem
      icon={<FaCashRegister />}
      label="ePOS"
      onClick={() => navigate("/ePOS")}
    />
  )}
  
  {/* MY SHOP */}
  {myShop && (
    <HomeMenuItem
      icon={<FaStore />}
      label="My Shop"
      onClick={() =>
        navigate(`/shop/${myShop.id}`)
      }
    />
  )}

  {/* DELIVERY DASHBOARD */}
  {isDeliveryPerson && (
  <div style={{ position: "relative" }}>

    <HomeMenuItem
      icon={<FaTruck />}
      label="Delivery Dashboard"
      onClick={() =>
        navigate("/delivery-dashboard")
      }
    />

    {/* DELIVERY AVAILABILITY BADGE */}
    {homeDeliveryIsAvailable && (
  <span
    style={{
      position: "absolute",
      top: 1,
      right: 1,

      minWidth: 22,
      height: 22,

      padding: "0 5px",

      borderRadius: 12,

      background: "#16a34a",
      color: "#fff",

      border: "2px solid #fff",

      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      fontSize: 9,
      fontWeight: 800,

      lineHeight: 1,

      boxShadow:
        "0 2px 5px rgba(0,0,0,0.2)",

      zIndex: 5,

      whiteSpace: "nowrap",
    }}
    title={`Available for ${homeDeliveryRemainingText}`}
  >
    {homeDeliveryRemainingMinutes}m
  </span>
)}

  </div>
)}

</div>

{/* =================================================
    DELIVERY READY NOTIFICATION
================================================= */}

{isDeliveryPerson && deliveryRequests.length > 0 && (

  <div
    className="home-delivery-alert"
    onClick={() =>
      navigate("/delivery-dashboard")
    }
  >

    <div className="home-delivery-alert-icon">
      🚚
    </div>

    <div className="home-delivery-alert-content">

      <strong>
        New Delivery Ready!
      </strong>

      <span>
        Order #{deliveryRequests[0].orderId}
      </span>

      <small>
        Tap to view & accept the delivery
      </small>

    </div>

    <div className="home-delivery-alert-arrow">
      →
    </div>

  </div>

)}

  {/* =================================================
      ACTIVITY CARDS
  ================================================= */}

  {homeActivities.length > 0 && (

    <div>

      <div
        className="home-activity-slider"
        onScroll={handleActivityScroll}
      >

        {homeActivities
          .slice(0, 5)
          .map((item) => (

            <div
              key={item.id}
              className="home-activity-slide"
            >

              <div
                className="home-activity-card"
                style={{
                  borderLeft:
                    `5px solid ${getActivityBorder(
                      item.priority,
                      item.type
                    )}`
                }}

                onClick={() => {

                  if (item.action) {

                    navigate(item.action);

                  } else {

                    navigate("/foryou");

                  }

                }}
              >

                {/* ICON */}

                <div className="home-activity-icon">

                  {getActivityIcon(item.type)}

                </div>


                {/* CONTENT */}

                <div className="home-activity-content">

                  <h4>
                    {item.title}
                  </h4>

                  <p>
                    {item.message}
                  </p>


                  {item.createdAt?.toDate && (

                    <small>

                      {item.createdAt
                        .toDate()
                        .toLocaleString()}

                    </small>

                  )}

                </div>

              </div>

            </div>

          ))}

      </div>


      {/* =================================================
          SLIDE DOTS
      ================================================= */}

      {homeActivities.length > 1 && (

        <div className="home-activity-dots">

          {homeActivities
            .slice(0, 5)
            .map((_, index) => (

              <button
                key={index}
                type="button"

                className={
                  `home-activity-dot ${
                    activeActivitySlide === index
                      ? "active"
                      : ""
                  }`
                }

                onClick={() => {

                  const slider =
                    document.querySelector(
                      ".home-activity-slider"
                    );

                  if (!slider) return;

                  slider.scrollTo({

                    left:
                      index *
                      slider.clientWidth,

                    behavior: "smooth",

                  });

                  setActiveActivitySlide(index);

                }}

                aria-label={
                  `Go to slide ${index + 1}`
                }

              />

            ))}

        </div>

      )}

    </div>

  )}

</div>



  {/* SHOPPING */}
  <HomeSection
  title="🛍 Shopping"
  sectionClassName="shopping-section"
>

  <HomeMenuItem
    icon={
      <ShoppingLottieIcon
        animation={allProductsAnimation}
      />
    }
    label="All Products"
    onClick={() => navigate("/allproducts")}
  />

  <HomeMenuItem
    icon={
      <ShoppingLottieIcon
        animation={allShopsAnimation}
      />
    }
    label="All Shops"
    onClick={() => navigate("/shops")}
  />

  <HomeMenuItem
    icon={
      <ShoppingLottieIcon
        animation={shopOrdersAnimation}
      />
    }
    label="My Shop Orders"
    badge={orderNotificationCount}
    onClick={() => navigate("/shop/orders")}
  />

  <HomeMenuItem
    icon={
      <ShoppingLottieIcon
        animation={myOrdersAnimation}
      />
    }
    label="My Orders"
    badge={orderNotificationCount}
    onClick={() => navigate("/orders")}
  />

</HomeSection>



{/* DISCOVER */}
<HomeSection title="📰 Discover">
  <HomeMenuItem
  icon={<FaBullhorn />}
  label="Posts"
  onClick={() => navigate("/posts")}
/>

  <HomeMenuItem
    icon={<FaMapMarkerAlt />}
    label="Local Updates"
    onClick={() => navigate("/localupdates")}
  />

  <HomeMenuItem
    icon={<FaNewspaper />}
    label="Info Exchange"
    onClick={() => navigate("/ie")}
  />

<HomeMenuItem
    icon={<FaBriefcase />}
    label="Jobs"
    onClick={() => navigate("/jobs")}
  />

{/*  
  <HomeMenuItem
    icon={<FaRobot />}
    label="AI Shop"
    onClick={() => navigate("/ai")}
  />

  <HomeMenuItem
    icon={<FaGamepad />}
    label="Play"
    onClick={() => navigate("/play")}
  />
  */}

</HomeSection>



  {/* TRANSPORT */}
  <HomeSection title="🚕 Transport">

    <HomeMenuItem
  icon={<FaTaxi />}
  label="Book Auto"
  onClick={() => navigate("/autos")}
/>

{/* TRANSPORT 
<HomeMenuItem
  icon={<FaUserPlus />}
  label="Join Driver"
  onClick={() => navigate("/join-auto")}
/>
*/}
<HomeMenuItem
  icon={<FaClipboardList />}
  label="Ride Requests"
  badge={rideRequestCount}
  onClick={() => navigate("/ride-requests")}
/>

<HomeMenuItem
  icon={<FaRoute />}
  label="My Rides"
  badge={myRideCount}
  onClick={() => navigate("/my-rides")}
/>

  </HomeSection>


{/* category scroll  */}
  <HomeSection title="🗂️ Categories"></HomeSection>
{/* =====================================================
    EYAL APP - PRODUCT CATEGORIES
    FIXED ORDER + CORRECT NAMES + CORRECT ICONS
===================================================== */}

{productCategories.length > 0 && (
  <section className="home-category-status">

    <div
      className="home-category-status-scroll"
      ref={categoryScrollRef}
    >

      {[
        ...productCategories,
        ...productCategories,
      ].map((category, index) => (

        <div
          key={`${category.name}-${index}`}
          className="home-category-status-tile"
          onClick={() =>
            navigate(
              `/allproducts?category=${encodeURIComponent(
                category.name
              )}`
            )
          }
        >

          {/* CATEGORY ICON */}

          <div className="home-category-status-icon">

            {getCategoryIcon(category)}

          </div>


          {/* CATEGORY NAME */}

          <div className="home-category-status-name">

            {category.name}

          </div>

        </div>

      ))}

    </div>

  </section>
)}


{/* products scroll  */}
  <HomeSection title="📦 Products Preview"></HomeSection>

 {/* =========================
    PRODUCTS STATUS TILES
========================== */}

{products.length > 0 && (
  <section className="home-product-status">

    <div
  className="home-product-status-scroll"
  ref={productsScrollRef}
>

      {products.map((product) => (

       <div
  key={`${product.source || "product"}-${product.product_id}`}
  className="home-product-status-tile"
  onClick={() => {

    if (product.source === "shop") {

      navigate(
        `/product/${product.product_id}?source=shop`
      );

    } else {

      navigate(
        `/product/${product.product_id}`
      );

    }

  }}
>

          {/* PRODUCT IMAGE */}
          {product.imageUrl || product.image ? (

            <img
              src={product.imageUrl || product.image}
              className="home-product-status-media"
              alt={product.name || "Product"}
            />

          ) : (

            <div className="home-product-status-placeholder">
              🛍️
            </div>

          )}

          {/* PRODUCT NAME */}
          <div className="home-product-status-name">
            {product.name || "Product"}
          </div>

          {/* PRICE 
          <div className="home-product-status-price">
            ₹{product.price || 0}
          </div>
*/}
        </div>

      ))}

    </div>

  </section>
)}

{/* 
         <SearchBar
  value={search}
  onChange={setSearch}
/>
*/}



{/* post composer  */}
  <HomeSection title="📝 Post your update!"></HomeSection>

  <PostComposer />
  

{/* post preview  */}
  <HomeSection title="✅ Posts preview!"></HomeSection>
  {/* =========================
      POSTS STATUS TILES
  ========================== */}

  {posts.length > 0 && (
    <section className="home-post-status">
 {/*
      <div className="home-post-status-header">
        <h3>📝 Posts</h3> 

        <button
          onClick={() => navigate("/posts")}
          className="home-post-see-all"
        >
          See all →
        </button>
      </div>
*/}
      <div
  className="home-post-status-scroll"
  ref={postsScrollRef}
>

        {posts.slice(0, 8).map((post) => (

          <div
            key={post.id}
            className="home-post-status-tile"
            onClick={() =>
  navigate(`/posts?post=${post.id}`)
}
          >

            {/* MEDIA */}
            {post.imageUrl ? (

              <img
                src={post.imageUrl}
                className="home-post-status-media"
                alt=""
              />

            ) : post.videoUrl ? (

              <video
                src={post.videoUrl}
                className="home-post-status-media"
                muted
                playsInline
                preload="metadata"
              />

            ) : (

              <div className="home-post-status-text">
                {post.text || "New Post"}
              </div>

            )}


            {/* PROFILE */}
            <div className="home-post-status-avatar">

              {post.userPhotoURL ? (

                <img
                  src={post.userPhotoURL}
                  alt=""
                />

              ) : (

                <FaUserCircle />

              )}

            </div>


            {/* USER NAME */}
            <div className="home-post-status-name">

              {post.userName || "User"}

            </div>

          </div>

        ))}

      </div>

    </section>
  )}

 
<div className="home-menu">

  
  {/* FOR YOU 

<HomeSection title="✨ For You">

  <HomeMenuItem
    icon={<FaRegCompass />}
    label="For You"
    badge={notificationCount}
    onClick={() => navigate("/foryou")}
  />

</HomeSection>
*/}


      {/* EARN WITH EYAL 
    <HomeSection title="💰 Earn with Eyal">

      <HomeMenuItem
        icon={<FaGift />}
        label="Invite & Earn"
        onClick={() => navigate("/invite")}
      />

  <HomeMenuItem
    icon={<FaTaxi />}
    label="Join Driver"
    onClick={() => navigate("/join-auto")}
  />

  <HomeMenuItem
    icon={<FaStore />}
    label="Join Shop"
    onClick={() => navigate("/user/shop")}
  />


 
  <HomeMenuItem
    icon={<FaMotorcycle />}
    label="Join Delivery Person"
    onClick={() => navigate("/join-delivery")}
  />

 
  <HomeMenuItem
    icon={<FaTruck />}
    label="Delivery Dashboard"
    onClick={() => navigate("/delivery-dashboard")}
  />


  <HomeMenuItem
    icon={<FaBullhorn />}
    label="Join Creators"
    onClick={() => navigate("/creators")}
  />


    </HomeSection>

*/}
  
  {/* SUPPORT 
  <HomeSection title="⚙ Support">

    <HomeMenuItem
      icon={<FaWhatsapp />}
      label="Contact Support"
      onClick={() =>
        window.open(
          "https://wa.me/918012044114",
          "_blank"
        )
      }
    />

  </HomeSection>
  */}

</div>

 {/* <FloatingActionButton /> */}

      </div>

  );

}